
import {
  MatCheckboxModule,
  MatButtonModule,
  MatInputModule,
  MatAutocompleteModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatFormFieldModule,
  MatRadioModule,
  MatSelectModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatMenuModule,
  MatSidenavModule,
  MatToolbarModule,
  MatListModule,
  MatGridListModule,
  MatCardModule,
  MatStepperModule,
  MatTabsModule,
  MatExpansionModule,
  MatButtonToggleModule,
  MatChipsModule,
  MatIconModule,
  MatProgressSpinnerModule,
  MatProgressBarModule,
  MatDialogModule,
  MatTooltipModule,
  MatTableModule,
  MatSortModule,
  MatPaginatorModule,
  MatSnackBarModule,
} from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';

const modules = [
MatCardModule,
MatIconModule,
MatInputModule,
MatButtonModule,
MatListModule,
MatFormFieldModule,
MatDialogModule,
MatProgressBarModule,
MatToolbarModule,
MatMenuModule,
MatSidenavModule,
MatSelectModule,
MatTabsModule,
MatTableModule,
MatSortModule,
MatPaginatorModule,
MatAutocompleteModule,
MatDatepickerModule,
MatNativeDateModule,
MatExpansionModule,
MatCheckboxModule,
MatProgressSpinnerModule,
MatTooltipModule,
MatSnackBarModule,
MatRadioModule 
];

@NgModule({
imports: modules,
exports: modules
})
export class MaterialComponentsModule { }
